import Reveal from "../components/Reveal";
import SectionLabel from "../components/SectionLabel";
import { useSite, resolveImg } from "../context/SiteContext";

export default function Gallery() {
  const { gallery } = useSite();
  return (
    <main data-testid="gallery-page" className="pt-32 pb-24 max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <SectionLabel>Gallery</SectionLabel>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-light max-w-4xl">Postcards from the <em className="not-italic font-medium">East</em>.</h1>
      </Reveal>
      <div className="mt-14 columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
        {gallery.map((g, i) => (
          <Reveal key={g.id || g.url} delay={(i % 4) * 0.04}>
            <div className="overflow-hidden rounded-2xl group break-inside-avoid relative">
              <img src={resolveImg(g.url)} alt={g.caption || "North East"} className="w-full transition-transform duration-[1500ms] group-hover:scale-110" loading="lazy" />
              {g.caption && (
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-white text-xs">{g.caption}</span>
                </div>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
